export interface IGroupNode {
  value: string
  label: string
}

const LEVEL_SEPARATOR = '>'
const ENTRY_SEPARATOR = '::'

export const makeGroupPath = (
  parentPath: string,
  fieldKey: string,
  entryId: string,
): string => {
  const segment = `${encodeURIComponent(
    fieldKey,
  )}${ENTRY_SEPARATOR}${encodeURIComponent(entryId)}`
  return parentPath ? `${parentPath}${LEVEL_SEPARATOR}${segment}` : segment
}

// Every ancestor prefix path for a record's group paths, used to enumerate the
// full set of collapsible group nodes (collapse-all / expand-all).
export const collectGroupPaths = (
  paths: IGroupNode[][],
  fieldKey: string,
): string[] => {
  const result: string[] = []
  paths.forEach(path => {
    let parentPath = ''
    path.forEach(groupNode => {
      parentPath = makeGroupPath(parentPath, fieldKey, groupNode.value)
      result.push(parentPath)
    })
  })
  return result
}
